import { render, staticRenderFns } from "./BlogTwoAd_buscador.vue?vue&type=template&id=71cad058&scoped=true&"
import script from "./BlogTwoAd_buscador.vue?vue&type=script&lang=js&"
export * from "./BlogTwoAd_buscador.vue?vue&type=script&lang=js&"
import style0 from "./BlogTwoAd_buscador.vue?vue&type=style&index=0&id=71cad058&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cad058",
  null
  
)

export default component.exports